import React from 'react';
import './FeaturedSection.css'; // Import the external CSS file

const FeaturedSection = () => {
  return (
    <div className="featured-section">
      <div className="jumbotron">
        <img className="jt-featured-image" src="Kanzis-Legacy-updated.png" alt="Memorial for Kanzi" />
        <div className="content">
          <h1 className="display-4">Kanzi's Legacy</h1>
          <p className="lead">A Humanities Lab Workshop<br />April 19, 2025, 1-6pm.</p>
          <hr className="my-4" />
          <p className="feature-p">The Humanities Lab at Cornell University is sponsoring a Memorial
            for Kanzi on April 19.  People may attend either in person or via Zoom.  Register for
            this event today!
          </p>
          <div className="sue-container">
            <a className="btn btn-primary btn-sue" href="https://blogs.cornell.edu/humanitieslab/kanzis-legacy-workshop/" target="_blank" rel="noreferrer" role="button">Learn more</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedSection;
